export default __webpack_public_path__ + "static/media/barrelSolution.e133d8ac.png";